goog.provide("shadow.js.shim.module$$react_navigation$stack");
goog.provide("module$shadow_js_shim_module$$react_navigation$stack");
shadow.js.shim.module$$react_navigation$stack = require("@react-navigation/stack");
module$shadow_js_shim_module$$react_navigation$stack.default = shadow.js.shim.module$$react_navigation$stack;
